 
import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";
 
import ConectUs from "../../components/ConectUs";
 
import { motion } from "framer-motion";
 
import ImageGallery from "../../components/ImageGallery";
 
import DescuentosEnlinea from "./DescuentosEnlinea";
import BlockRightImage from "../../components/BlockRightImage";
import OfferLinea from "../../components/view/OfferLinea";

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/4e980ff0-58d6-4d01-9ac3-dc7e149d2865" +
  "?include=field_imagen_portada.field_media_image,field_gallery.field_media_image,field_imagen2.field_media_image" +
  "&fields[node--template_home]=title,field_gallery,field_imagen_portada,field_imagen2,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

function Enlinea() {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
        when: "beforeChildren",
        staggerChildren: 0.2,
      },
    },
  };

  const DataDisplay = ({ data }) => (
    <div>
      <div className="mt-[65px]">
        <img src={data.imagen_portada} alt="cabecera" />{" "}
      </div>
      <section className="max-w-5xl mx-auto my-10 px-4 sm:px-6 lg:px-0">
        <div className="flex flex-col lg:flex-row items-center gap-8 bg-gradient-to-br from-[#004270] via-[#002f52] to-slate-950 rounded-2xl shadow-xl border border-[#febe10]/20 ">
          <motion.div
            className="w-full lg:w-3/5"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <div
              dangerouslySetInnerHTML={{ __html: data.texto_portada }}
              className="p-8
        /* Badge */
        [&_h4]:inline-flex
        [&_h4]:items-center
        [&_h4]:justify-center
        [&_h4]:text-xs
        [&_h4]:uppercase
        [&_h4]:text-[#febe10]
        [&_h4]:bg-[#febe10]/10
        [&_h4]:px-3
        [&_h4]:py-1.5
        [&_h4]:rounded-full
        [&_h4]:border
        [&_h4]:border-[#febe10]/30
        [&_h4]:w-full
        [&_h4]:sm:w-fit
        [&_h4]:max-w-full
        [&_h4]:text-center
        [&_h4]:mb-4

        /* Título */
        [&_h2]:text-2xl
        [&_h2]:md:text-3xl
        [&_h2]:font-bold
        [&_h2]:text-white
        [&_h2]:leading-tight
        [&_h2]:max-w-3xl
        [&_h2_strong]:text-[#febe10]

        /* Botón */
        [&_a]:inline-flex
        [&_a]:items-center
        [&_a]:justify-center
        [&_a]:px-6
        [&_a]:py-3
        [&_a]:mt-6
        [&_a]:text-sm
        [&_a]:font-bold
        [&_a]:text-slate-900
        [&_a]:bg-[#febe10]
        [&_a]:hover:bg-[#e0a60b]
        [&_a]:rounded-xl
        [&_a]:shadow-lg
        [&_a]:transition-all
        [&_a]:duration-200
        [&_a]:hover:scale-[1.02]
        "
            />
          </motion.div>
          {data.galeria && (
            <div className="w-full lg:w-2/5">
              <ImageGallery gallery={data.galeria} />
            </div>
          )}
        </div>
      </section>
      <div
        className="text-center px-6"
        dangerouslySetInnerHTML={{ __html: data.bloque1 }}
      />
      <div className="pb-16 pt-4">
 
        <OfferLinea></OfferLinea>
        
      </div>
      <div>
        <DescuentosEnlinea></DescuentosEnlinea>
      </div>

      <div className="mt-10 bg-slate-50">
        <BlockRightImage
          src={data.imagen2}
          content={
            <>
              <div dangerouslySetInnerHTML={{ __html: data.bloque2 }} />
            </>
          }
        ></BlockRightImage>{" "}
      </div>
    </div>
  );

  return (
    <>
      <DataFetcherTemplateHome url={url}>
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplateHome>

      <div className="my-10 pt-4">
        <ConectUs
          lema="Descubre contenido exclusivo, mantente al tanto de las últimas novedades y únete a nuestra comunidad de estudiantes."
          instagram="https://www.instagram.com/utplenlinea/"
          facebook="https://www.facebook.com/utplenlinea/"
          tiktok="https://www.tiktok.com/@utplenlinea"
        ></ConectUs>
      </div>
    </>
  );
}

export default Enlinea;
